import type { UtilsTranslations } from './utils.translations.pl.ts';

const unexpectedError = 'An unexpected error occurred. Please try again.';

export const utilsTranslations: UtilsTranslations = {
  errors: {
    unexpectedError,
  },
  network: {
    '400_1': unexpectedError,
    '400_6': 'This question has already been answered',
    '409_1':
      "Your quiz is already finished - if you haven't received feedback yet, we'll email it to you soon!",
    '409_2': 'The time to complete the quiz is up',
    '409_3': 'The allowed number of returns to the quiz has been exceeded',
    '409_closed': 'Applications are now closed',
    '403_ip':
      'The admin panel only works from the company network. Your IP address ({{ip}}) is not on the allowed list: connect through the VPN or ask for the address to be added.',
    '401': 'Your session has expired. Please log in again.',
    '409': unexpectedError,
    '500': unexpectedError,
    loginError: "I can't log you in - the token is invalid or has expired",
  },
};
